import { Button } from '@/components/basic';
import { Modal } from '@/components/basic/Modal';
import { useCreatePermissionProvider } from '@/components/permissions/CreatePermission/CreatePermissionProvider';
import LoadingSpinner from '@/components/util/LoadingSpinner';
import React from 'react';

export interface AddAssignmentModalFooterProps {
  onClose: () => void;
}

export const AddAssignmentModalFooter: React.FC<
  AddAssignmentModalFooterProps
> = ({ onClose }) => {
  const { isLoading, form } = useCreatePermissionProvider();
  const users = form.watch('users', []);
  const teams = form.watch('teams', []);
  const allUsers = form.watch('allUsers', false);
  return (
    <Modal.Footer>
      <Button
        className="w-full sm:w-auto"
        layout="squared"
        variant="white"
        font="boldGray"
        onClick={onClose}
      >
        Cancel
      </Button>
      <Button
        className="mt-4 w-full sm:mt-0 sm:ml-3 sm:w-auto"
        layout="squared"
        variant="primary"
        type="submit"
        form="createOrEditHourRule"
        disabled={
          isLoading || users.length + teams.length + (allUsers ? 1 : 0) === 0
        }
      >
        {isLoading ? <LoadingSpinner color="text-white" /> : <span>Save</span>}
      </Button>
    </Modal.Footer>
  );
};
